// extracted by mini-css-extract-plugin
export var author = "index-module--author--01W14";
export var authorImg = "index-module--authorImg--k+7D2";
export var authorMeta = "index-module--authorMeta--OANqM";
export var authorMetaBottom = "index-module--authorMetaBottom--xVlD8";
export var authorMetaTitle = "index-module--authorMetaTitle--vbSmM";
export var authorMetaTop = "index-module--authorMetaTop--kwCty";
export var backLink = "index-module--backLink--sDsr+";
export var blackCircle = "index-module--blackCircle--kVtLc";
export var content = "index-module--content--lpm4h";
export var date = "index-module--date--R7lo8";
export var defaultImageContainer = "index-module--defaultImageContainer--coWV1";
export var defaultImageInnerContainer = "index-module--defaultImageInnerContainer--5AkfN";
export var hero = "index-module--hero--rBrLS";
export var inlineGatsbyImageWrapper = "index-module--inline-gatsby-image-wrapper--ZpzFP";
export var leftArrow = "index-module--leftArrow--b64yf";
export var ousterBlogDetail = "index-module--ousterBlogDetail--c1H6Z";
export var title = "index-module--title--u7hZt";
export var wrapper = "index-module--wrapper--V0G3p";